import _defineProperty from "@babel/runtime/helpers/defineProperty";
import cc from 'classcat';
import PropTypes from 'prop-types';
import Icon from '../icons/EverGreen';
import css from './EverGreen.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var EverGreen = function EverGreen(_ref) {
  var _ref2;

  var center = _ref.center,
      small = _ref.small,
      large = _ref.large;
  return /*#__PURE__*/_jsxs("div", {
    className: cc([css.root, (_ref2 = {}, _defineProperty(_ref2, css.center, center), _defineProperty(_ref2, css.small, small), _defineProperty(_ref2, css.large, large), _ref2)]),
    children: [/*#__PURE__*/_jsx("div", {
      className: css.icon,
      children: /*#__PURE__*/_jsx(Icon, {})
    }), !small && /*#__PURE__*/_jsx("p", {
      className: css.description,
      children: "Our line of sustainable fabrics developed through a lens of longevity. Made from over 50% preferred materials in an effort to reduce our environmental impact."
    })]
  });
};

EverGreen.defaultProps = {
  center: false,
  large: false,
  small: false
};
EverGreen.propTypes = {
  center: PropTypes.bool,
  large: PropTypes.bool,
  small: PropTypes.bool
};
export default EverGreen;